import { type BillingAction, BillingActionTypes, BillingPhase, type BillingState } from './types'

export const initialBillingState: BillingState = {
  subscription: null,
  phase: BillingPhase.Loading,
  provisioningSinceMs: null,
  loading: true,
  error: null
}

export function billingReducer(state: BillingState, action: BillingAction): BillingState {
  switch (action.type) {
    case BillingActionTypes.SET_SUBSCRIPTION:
      return {
        ...state,
        subscription: action.payload,
        // An absent document isn't an empty state here — it means provisioning hasn't finished.
        // See BillingPhase.Provisioning for why that's distinguishable rather than a guess.
        phase: action.payload ? BillingPhase.Ready : BillingPhase.Provisioning,
        // Stamped on the FIRST absent snapshot and not refreshed by later ones, so elapsed time
        // reflects how long provisioning has actually been outstanding.
        provisioningSinceMs: action.payload ? null : (state.provisioningSinceMs ?? action.nowMs),
        loading: false,
        error: null
      }
    case BillingActionTypes.SET_ERROR:
      // Phase stays where it was: a dropped subscription doesn't mean the document vanished, and
      // demoting to Provisioning here would flash a settling state at an established account.
      return { ...state, loading: false, error: action.payload }
    case BillingActionTypes.CLEAR:
      return { ...initialBillingState }
    default:
      return state
  }
}
